"use client";

import Link from "next/link";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 p-6 text-center" style={{ background: "var(--color-canvas)", color: "var(--color-espresso)" }}>
      <p className="font-mono text-xs uppercase tracking-[0.08em] opacity-60">Something went wrong</p>
      <h1 className="text-[28px] font-semibold m-0">We hit a temporary snag</h1>
      <p className="max-w-[440px] text-[15px] leading-relaxed opacity-75 m-0">
        The page could not be rendered just now. Retry below, or head back to the homepage.
      </p>
      {error.digest ? <p className="font-mono text-xs opacity-50">Ref: {error.digest}</p> : null}
      <div className="flex gap-3 flex-wrap justify-center">
        <button
          onClick={reset}
          className="inline-flex items-center justify-center gap-1.5 rounded-full bg-ink px-[18px] py-2.5 text-sm font-medium text-white min-h-11 border-0 cursor-pointer"
        >
          Try again
        </button>
        <Link
          href="/"
          className="inline-flex items-center justify-center gap-1.5 rounded-full bg-transparent px-[18px] py-2.5 text-sm font-medium text-ink min-h-11 border-0"
          style={{ boxShadow: "var(--shadow-hairline)" }}
        >
          Back to homepage
        </Link>
      </div>
    </div>
  );
}
